import analyze from 'guardian-liveness-detection-lib/src/libs/analyze'

export const enum CheckResultType {
  FILE_SUFFIX_NOT_MATCH = 'FILE_SUFFIX_NOT_MATCH',
  DURATION_TOO_SHORT = 'DURATION_TOO_SHORT',
  DURATION_TOO_LONG = 'DURATION_TOO_LONG',
  UPLOAD_DIRECTLY = 'UPLOAD_DIRECTLY',
  NEED_RESOLVE = 'NEED_RESOLVE',
}

interface IFileObj {
  file: File,
  video?: HTMLVideoElement
}

// common case: mp4, mov, webm, gif
const ACCEPT_SUFFIX = [
  'mp4', 'avi', 'flv', 'wmv', 'mov', 'rm', 'gif', 'webm', '3gp',
]

// kb
const MAX_SIZE = 1024 * 1 // 1M
const MIN_DURATION = 2 // s
const MAX_DURATION = 12 // s

export async function checkHandler(fileObj: IFileObj): Promise<{
  type: CheckResultType,
  fileObj: IFileObj,
}> {
  const fileSuffix = fileObj.file.name.split('.')[1]
  const fileType = fileObj.file.type.split('/')[0]

  return new Promise((resolve, reject) => {

    if (!ACCEPT_SUFFIX.includes(fileSuffix.toLowerCase()) && fileType !== 'video') {
      console.warn('fileSuffix', fileSuffix)
      return resolve({ type: CheckResultType.FILE_SUFFIX_NOT_MATCH, fileObj })
    }

    if (!fileObj.video) {
      // upload
      // console.log('upload directly', fileObj.file)
      return resolve({ type: CheckResultType.UPLOAD_DIRECTLY, fileObj })
    }

    const videoInfo = analyze(fileObj.file, fileObj.video)
    const { duration, size } = videoInfo

    if (!duration) {
      return resolve({ type: CheckResultType.UPLOAD_DIRECTLY, fileObj })
    }

    if (duration <= MIN_DURATION) {
      console.warn('duration too short', duration)
      return resolve({ type: CheckResultType.DURATION_TOO_SHORT, fileObj })
    }

    if (duration >= MAX_DURATION) {
      console.warn('duration too long', duration)
      return resolve({ type: CheckResultType.DURATION_TOO_LONG, fileObj })
    }

    // IOS will compress the video into a picture, and now upload it directly
    if (size <= MAX_SIZE || /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      // console.log('file org size -- upload', size)
      return resolve({ type: CheckResultType.UPLOAD_DIRECTLY, fileObj })
    }

    resolve({ type: CheckResultType.NEED_RESOLVE, fileObj })
  })
}
